import MUITextField from '@mui/material/TextField';
import { FormHelperText } from '@mui/material';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEntityPermission } from '../../providers/EntityPermissionProvider/index';
import ReadOnly from './ReadOnly';

const TextField = forwardRef(
  (
    {
      type = 'text',
      error = null,
      helperText = '',
      overwriteProps = {},
      ...props
    },
    ref,
    // eslint-disable-next-line arrow-body-style
  ) => {
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return <ReadOnly name={props?.name}>{currentvalue}</ReadOnly>;
    }

    if (isHidden(props?.permission)) {
      return <input type="hidden" name={props?.name} value={currentvalue} />;
    }

    const handleBlur = event => {
      const value = event.target.value.trim();
      // eslint-disable-next-line no-param-reassign
      event.target.value = value;
      if (props?.onBlur) {
        props?.onBlur(event);
      }
    };

    return (
      <>
        <MUITextField
          ref={ref}
          type={type}
          error={!!error}
          variant="outlined"
          {...props}
          onBlur={handleBlur}
          fullWidth
          size="small"
          autoComplete="off"
          {...overwriteProps}
        />
        {error || helperText ? (
          <FormHelperText sx={{ typography: 'body2' }} error={Boolean(error)}>
            {error || helperText}
          </FormHelperText>
        ) : null}
      </>
    );
  },
);

export default TextField;
